document.addEventListener('DOMContentLoaded', function () {

    const wrapper = document.querySelector('.wls-product-benefits__wrapper');
    const sliderEl = document.querySelector('#wls-product-benefits__slider');
    if (!wrapper || !sliderEl) return;

    const pills = Array.from(wrapper.querySelectorAll('.wls-product-benefits__pill .wls-product-benefits__pill-text'));
    if (pills.length === 0) return;

    const imageEl = wrapper.querySelector('.wls-product-benefits__image');

    /* =========================
       DYNAMIC NUMBERS (DESKTOP)
    ========================== */
    pills.forEach((_, index) => {
        const span = document.createElement('span');
        span.className = `wls-product-benefits__image-num wls-product-benefits__image-num--${index + 1}`;
        span.textContent = index + 1;
        imageEl.appendChild(span);
    });

    const imageNums = Array.from(imageEl.querySelectorAll('.wls-product-benefits__image-num'));

     /* =========================
       FILL SLIDER
    ========================== */
    const sliderList = sliderEl.querySelector('.splide__list');

    pills.forEach((pill, index) => {
        const li = document.createElement('li');
        li.className = 'splide__slide';

        const box = document.createElement('div');
        box.className = 'wls-product-benefits__slider-box';

        const num = document.createElement('span');
        num.className = 'wls-product-benefits__pill-num';
        num.textContent = index + 1;

        const text = document.createElement('span');
        text.className = 'wls-product-benefits__pill-text';
        text.textContent = pill.textContent;

        box.appendChild(num);
        box.appendChild(text);
        li.appendChild(box);
        sliderList.appendChild(li);
    });

    /* =========================
       SPLIDE INIT
    ========================== */
    const sliderBenefits = new Splide(sliderEl, {
        type: 'loop',
        perPage: 1,
        gap: 8,
        pagination: false,
        arrows: false,
    });
    sliderBenefits.mount();

    /* =========================
       SYNC NUMBERS ↔ SLIDER
    ========================== */
    imageNums.forEach((numEl, index) => {
        numEl.addEventListener('click', () => {
            sliderBenefits.go(index);
            setActiveImageNum(index);
        });
    });

    sliderBenefits.on('move', function(newIndex) {
        setActiveImageNum(newIndex);
    });

    function setActiveImageNum(activeIndex) {
        imageNums.forEach((el, i) => {
            el.classList.toggle('is-active', i === activeIndex);
        });
    }

    setActiveImageNum(0);

});